// theirs

// ours
import classNames from 'classnames'
import { ContentDataModel } from '../../../interfaces'
import {
    appendLocationMultiple,
    appendLocationSingle,
    appendSizes,
} from '../../../utils/append-location'
import { imageAndTextQuoteBaseClass, StyledImageAndTextQuote } from './style'

export interface ImageAndTextQuoteProps {
    className?: string
    testId?: string
    content: ContentDataModel
}

const ImageAndTextQuote = ({
    className,
    testId,
    content,
}: ImageAndTextQuoteProps) => {
    return (
        <StyledImageAndTextQuote
            className={classNames(imageAndTextQuoteBaseClass, className)}
            content={content}
        >
            <div className="content-outer">
                <div className="content-inner">
                    {content.contentPicture && (
                        <div className="image-wrapper">
                            {content.contentPicture.map((picture, index) => (
                                <picture
                                    key={index}
                                    className={picture.contentPictureClass}
                                    data-testid={picture.contentPictureTestId}
                                >
                                    <img
                                        src={appendLocationSingle(
                                            'images',
                                            picture.contentPictureImageSource
                                        )}
                                        alt={
                                            picture.contentPictureImageAlternateText
                                        }
                                        {...(picture.contentPictureSource && {
                                            srcSet: appendLocationMultiple(
                                                'images',
                                                picture.contentPictureSource
                                            ),
                                            sizes: appendSizes(
                                                picture.contentPictureSource
                                            ),
                                        })}
                                    />
                                </picture>
                            ))}
                        </div>
                    )}
                    {content.contentText && (
                        <div className="text-wrapper">
                            <h2
                                className="text"
                                dangerouslySetInnerHTML={{
                                    __html: content.contentText,
                                }}
                            />
                            <p
                                className="author"
                                dangerouslySetInnerHTML={{
                                    __html: content.contentTextAuthorName || '',
                                }}
                            />
                        </div>
                    )}
                </div>
            </div>
        </StyledImageAndTextQuote>
    )
}

export default ImageAndTextQuote
